
export const headerData = {
    name: 'Ruifan Wang',
    abreviation: 'R W',
    title: "Hello! I am",
    desciption: "Hello! I am Ruifan Wang, a passionate full-stack developer who is driven by the impact of his work. A quick learner with a self-motivating attitude, I thrive in challenging environments.  I eagerly embrace diverse learning experiences that enable me to delve into novel domains and technologies, fostering my personal and professional growth.",
    ProfileImage: '/img/profile.jpg',
    imagebw: 'https://i.ibb.co/Cw2Xp90/abu-said-bw.jpg',
    resumePdf: 'https://docs.google.com/document/d/1U2I2RSV3fTG4EImTvrVGfVaXrhVsCjnOY8s2qhz28hM/export?format=pdf'
}
